import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import all translation files statically to avoid dynamic import issues
import enTranslations from './locales/en/translation.json';
import deTranslations from './locales/de/translation.json';
import esTranslations from './locales/es/translation.json';
import frTranslations from './locales/fr/translation.json';
import itTranslations from './locales/it/translation.json';

// Define the resources object with all translations
const resources = {
  en: {
    translation: enTranslations,
  },
  de: {
    translation: deTranslations,
  },
  es: {
    translation: esTranslations,
  },
  fr: {
    translation: frTranslations,
  },
  it: {
    translation: itTranslations,
  },
};

i18n.use(initReactI18next).init({
  debug: false,
  resources,
  fallbackLng: (code) => {
    if (!code) return ['en']; // default language is english

    if (code.startsWith('de')) return ['de'];

    return ['en'];
  },
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
